import { TaskStatus } from "../tasks.types";

type FarmStatusInput = {
  /** Status tracked locally in the button, set the moment a claim succeeds. */
  localStatus?: string;
  /** Status of the server-side TaskProcess row, when one exists. */
  processStatus?: TaskStatus;
  /** The user's DON balance from the profile endpoint, still unparsed. */
  walletAmount?: string;
  /** How much the task requires the user to have farmed. */
  targetFarmCount: string;
};

/** Decide which button a FARM task should show.
 *
 * The subtlety is that a TaskProcess row does *not* mean the task is done. The
 * row is written by the very first "check" tap, including one the server
 * answered INCOMPLETE because the balance was still short. Reading its mere
 * existence as "done" showed a disabled, greyed-out button to users who went on
 * to cross the target, so they could never claim what they had earned.
 */
export const resolveFarmTaskStatus = ({
  localStatus,
  processStatus,
  walletAmount,
  targetFarmCount,
}: FarmStatusInput): TaskStatus => {
  // Local status wins right after a claim: the task-list cache patch that fills
  // user_process only fires for a categorized list, so without this the button
  // falls back to "Olish" even though the DON has already been credited.
  if (localStatus === TaskStatus.Completed) return TaskStatus.Completed;
  if (walletAmount === undefined) return TaskStatus.Incomplete;

  // Only COMPLETED means the DON actually landed.
  if (processStatus === TaskStatus.Completed) return TaskStatus.Completed;
  // An already-verified claim stays claimable even if the balance has since
  // dipped below the target — the server short-circuits on READY_AWARD too.
  if (processStatus === TaskStatus.ReadyAward) return TaskStatus.ReadyAward;

  return parseFloat(walletAmount) >= parseFloat(targetFarmCount)
    ? TaskStatus.ReadyAward
    : TaskStatus.Incomplete;
};
